<template>
    <div class="hero-section">
      <div class="hero-content">
        <h1 class="title-results">Precios y opciones</h1>
        <p class="description-Results text-center">
            Haz el diagnóstico gratuito. 
            <br>
            Elige el plan que más te convenga.
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContactUsSection'
  }
  </script>
  
  <style scoped>
  .hero-section {
    width: 100%;
    height: 700px;
    background: url('../../assets/img/image3.jpg') no-repeat center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .hero-content {
    display: flex;
    max-height: 1400px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: center;
  }

  @media (max-width: 768px) {
    .hero-section {
      height: auto;
      min-height: 180px;
      padding: 10px 0;
      background-size: cover;
    }
    .hero-content {
      gap: 12px;
      padding: 0 2vw;
      max-width: 100%;
    }
    .title-results {
      font-size: 1.1rem;
      padding: 0 16px;
      line-height: 1.15;
      word-break: break-word;
      margin-top: 50px !important; /* <-- Más separación debajo del título */
    }
    .description-Results {
      font-size: 0.97rem;
      padding: 0 2vw;
      line-height: 1.3;
      word-break: break-word;
    }
  }
  </style>
